import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

interface IProps {
    className?: string;
    style?: any;
}

export const Product: React.FunctionComponent<IProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 64 64" {...props}>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g>
                    <rect x="0" y="0" width="64" height="64"></rect>
                    <g transform="translate(5.000000, 5.000000)">
                        <path
                            d="M1.83157895,25.5518797 L25.5203008,1.86315789 C26.5849624,0.798496241 28.1819549,0.266165414 29.7789474,0.266165414 L47.0796992,2.12932331 C49.475188,2.39548872 51.6045113,4.25864662 51.8706767,6.92030075 L53.7338346,24.2210526 C54,25.8180451 53.4676692,27.4150376 52.1368421,28.4796992 L28.4481203,52.1684211 C26.318797,54.2977444 23.124812,54.2977444 20.9954887,52.1684211 L1.83157895,33.0045113 C-0.297744361,30.875188 -0.297744361,27.681203 1.83157895,25.5518797 Z"
                            stroke="currentColor"
                            strokeWidth="4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <circle fill="currentColor" fillRule="nonzero" cx="41" cy="13" r="3"></circle>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};
